import { Accordion as BaseAccordion } from './Accordion'
import { AccordionButton } from './AccordionButton'
import { AccordionDetails } from './AccordionDetails'
import { AccordionGroup } from './AccordionGroup'

export type AccordionComponent = typeof BaseAccordion & {
  Button: typeof AccordionButton
  Details: typeof AccordionDetails
  Group: typeof AccordionGroup
}

export const Accordion = BaseAccordion as AccordionComponent

Accordion.Button = AccordionButton
Accordion.Details = AccordionDetails
Accordion.Group = AccordionGroup
